
import { Base } from '../base-component';

import './country-selector.component.scss';

import * as $ from 'jquery';

export class CountrySelector extends Base {

	countries: Array<any>;

	constructor(element: Element){
		
		super(element);
				
	}
		
	init(){

		this.countries = [];

		$('.country-selector__section-country').each((index, el) => {
			
			this.countries.push({ 
				country: $(el).data('country'), 
				section: $(el).data('section'), 
				element: $(el) 
			});

		});

	}
		
	bindEvents() {

		$('.country-selector__close').click(() => {
			
			$('.country-selector__modal').addClass('country-selector__modal--disappear');
				
			setTimeout(()=>{

				$('.country-selector__modal')
				.removeClass('country-selector__modal--reveal')
				.removeClass('country-selector__modal--disappear');

			},400);
			
		});

		$('.country-selector__search-input').keyup(() => {
			
			let searchParam = ($('.country-selector__search-input').val() as string).toLowerCase();
			
			if (searchParam.length > 0) {

				$('.country-selector__section').hide();
				$('.country-selector__section-country').hide();
				
				this.countries.filter((item, index) => {
					return item.country.toLowerCase().indexOf(searchParam) > -1;
				}).forEach((country) => {
					country.element.show();
					$(`.country-selector__section[data-section='${country.section}']`).show();
				});

			} else {

				this.countries.forEach((country) => {
					country.element.show();
					$(`.country-selector__section`).show();
				});

			}

		});

	}

}


// WEBPACK FOOTER //
// ./components/country-selector/country-selector.component.ts